 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		65: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		65: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~be20fca5","3":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~cf939e27","4":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile~stylequiz","7":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","8":"BuyItAgainTypeaheadPreWrapper","9":"ratings-and-reviews-mobile","10":"buybox~promotion-products-lazy","11":"compare~orange-lens","12":"media-gallery-filmstrip-mobile~media-gallery-overlay-mobile","13":"media-gallery-overlay~media-gallery-overlay-mobile","14":"orange-lens~reverse-image-search","15":"ratings-and-reviews-desktop","18":"StoreLayout","19":"aisle-bay","20":"augmented-reality","21":"bath-renovation","22":"breadcrumbs","23":"browse-and-search","24":"browse-and-search-mobile","25":"buybox","26":"calculator-pipcalculator","27":"collections","28":"collections-mobile","29":"compare","30":"consumer-card-messaging","31":"customer-image-overlay","32":"drawer","33":"emt-generated-content","34":"emt-links","35":"fulfillment","36":"global-custom-configurator","38":"home","39":"magic-apron","40":"measurement-guide","41":"measurement-guide-overlay-content","42":"media-gallery-filmstrip-mobile","43":"media-gallery-overlay","44":"media-gallery-overlay-mobile","45":"message-types","46":"orange-lens","47":"order-sample","48":"order-sample-drawer","49":"overlay","50":"paint-reorder","51":"paint-reorder-mobile","52":"pep","53":"pep-mobile","54":"product","55":"product-mobile","56":"product-overview","57":"promotion-products-lazy","58":"question","59":"questions-and-answers","60":"quick-view","61":"ratings-and-reviews","62":"results","63":"returns-messaging","64":"reverse-image-search","66":"share-to-email-overlay","67":"share-to-pinterest-overlay","68":"size-guide-overlay","69":"specifications","70":"stylequiz","71":"vendor-collection-products","72":"vendor-collections","73":"vendor-collections-mobile","75":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"04d55148df54a27ddf6e","1":"c9bd4f4a79f210479086","2":"64d0dfd06cce591f6dc1","3":"fb78a020c16e0948a323","4":"c002a6f35b7d516b84a8","5":"857c24e40e0111987e47","6":"dc2743db61f3bbcf6f62","7":"d7f60db8da12f3476e17","8":"70becd6250011bb10c1d","9":"b94f44b6a72ece3fd0c5","10":"143d6ccf6e7d2c5ad519","11":"d00cf1d1956bf0b83d34","12":"3345ac53256c6b96d50b","13":"19ae92a1fd0b1c9bb3f6","14":"c774bb8d0f3b801a119b","15":"2594bc7785feb9fd4a27","16":"65a5d4f8e7d20f36d4f6","17":"576316578b3f2ffae934","18":"d57ca7d7f279fb4981bc","19":"f64017b6d91c7f65535e","20":"c19a585a8fe3de4e93b3","21":"4d4a77ff6d72a75f5c4a","22":"5e6b63ed31fc5e4d1803","23":"7b7e13a0a3945e01b1af","24":"d215c530e181c9b2abb7","25":"0c6637c61cc16a1dc965","26":"1a7679851ad86691b5c8","27":"3d21b742f2ae97cc70a0","28":"17a9ebdc010eabdef8a3","29":"fbf9675f0dc0fbb76ecb","30":"53d6c48780373d4d3839","31":"8bcd6b8f67e23545a5ef","32":"3110a4b1b337f6446c0d","33":"c28acbaa998118bb6bfb","34":"34bf9d9be7d2db231acc","35":"4a40f35abcd416bd41f7","36":"dfca155fe3da8f6ca28d","38":"b2b76ae4c8e92984e064","39":"0cee4cc247a63339f77d","40":"801d916a8bd79b10dd9d","41":"d32ee476e5e8909a8ea3","42":"8dd11f03407f37b99d52","43":"d58f66bf2801e537f150","44":"e6c7843a07c415a6c349","45":"3b508d1a8c517a8ef2fb","46":"4d3df2eb035e6ac162dd","47":"4a5dfeb9499975462d03","48":"5327a42c7b84e86c9b0a","49":"43d6e4b23cdae1ed0c20","50":"01a8474ccb568af7466b","51":"0a92371a314f171ba64a","52":"a1511d785ca438b6ebbe","53":"a642a0ecf5ee00bde073","54":"ce312dd48c87761f1a38","55":"a92dd63d33cd1e1f997e","56":"4a4e1c16db777cb1198d","57":"29879e45a589e1b33876","58":"c020837fd0f6a03a7448","59":"4188f6063bc59a38f997","60":"3f0d87a07c6aa0e62519","61":"9f1f4c986b1f30a8da9a","62":"33c73ba4e28be8979554","63":"87cea00324fe1e6a2eef","64":"9e77c72f986411339ee7","66":"d597e7e3bd7496ada4e0","67":"bbc8fbe852ed84e2594e","68":"b5baabf6d4bc091f5ad8","69":"16eb5b8af43de9908b1f","70":"e6eb0cb0ca025d30fd1e","71":"2a1ba66e03419465dcac","72":"007fb6f21590456f6234","73":"966ef8106d9b26760a49","75":"1eba3c28181572f30a34","76":"40952bd034b02d91de0b","77":"0006743c32bc2c49283c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"6":1,"7":1,"9":1,"10":1,"13":1,"14":1,"19":1,"21":1,"23":1,"24":1,"25":1,"27":1,"28":1,"29":1,"30":1,"32":1,"33":1,"35":1,"36":1,"39":1,"42":1,"43":1,"44":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"59":1,"60":1,"61":1,"62":1,"70":1,"71":1,"72":1,"73":1,"75":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~be20fca5","3":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~cf939e27","4":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile~stylequiz","7":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","8":"BuyItAgainTypeaheadPreWrapper","9":"ratings-and-reviews-mobile","10":"buybox~promotion-products-lazy","11":"compare~orange-lens","12":"media-gallery-filmstrip-mobile~media-gallery-overlay-mobile","13":"media-gallery-overlay~media-gallery-overlay-mobile","14":"orange-lens~reverse-image-search","15":"ratings-and-reviews-desktop","18":"StoreLayout","19":"aisle-bay","20":"augmented-reality","21":"bath-renovation","22":"breadcrumbs","23":"browse-and-search","24":"browse-and-search-mobile","25":"buybox","26":"calculator-pipcalculator","27":"collections","28":"collections-mobile","29":"compare","30":"consumer-card-messaging","31":"customer-image-overlay","32":"drawer","33":"emt-generated-content","34":"emt-links","35":"fulfillment","36":"global-custom-configurator","38":"home","39":"magic-apron","40":"measurement-guide","41":"measurement-guide-overlay-content","42":"media-gallery-filmstrip-mobile","43":"media-gallery-overlay","44":"media-gallery-overlay-mobile","45":"message-types","46":"orange-lens","47":"order-sample","48":"order-sample-drawer","49":"overlay","50":"paint-reorder","51":"paint-reorder-mobile","52":"pep","53":"pep-mobile","54":"product","55":"product-mobile","56":"product-overview","57":"promotion-products-lazy","58":"question","59":"questions-and-answers","60":"quick-view","61":"ratings-and-reviews","62":"results","63":"returns-messaging","64":"reverse-image-search","66":"share-to-email-overlay","67":"share-to-pinterest-overlay","68":"size-guide-overlay","69":"specifications","70":"stylequiz","71":"vendor-collection-products","72":"vendor-collections","73":"vendor-collections-mobile","75":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"d72ddc6d6ad5d75cad74","1":"ae101fda583e7f2b6c7f","2":"2033e2b2c7759f5f4cb0","3":"993d4999fdb3e390bd0c","4":"50d430c72ccc3cf96a34","5":"31d6cfe0d16ae931b73c","6":"4f5b608ec38d0792d47e","7":"f5a53b21f1e96abc5167","8":"31d6cfe0d16ae931b73c","9":"6f5b9f83e7f38438fd0d","10":"7b5857f17ea967e685b8","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"656a4c97540ecf3cff26","14":"89d9163eeb30e835d559","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"853e5ca78c8a7aa34a62","20":"31d6cfe0d16ae931b73c","21":"5033e42da1bac3702418","22":"31d6cfe0d16ae931b73c","23":"04325c0196b8f52260d1","24":"c304a302ee7e7355bf1d","25":"38d2233ec62d32df2250","26":"31d6cfe0d16ae931b73c","27":"259fd42e66701e617d51","28":"dbbca90b242ea0fcb2b8","29":"21826578c6df476105cb","30":"eb405aa31c203a69394d","31":"31d6cfe0d16ae931b73c","32":"5521673608a60d69edf8","33":"b49004ddac99adec2224","34":"31d6cfe0d16ae931b73c","35":"ddf04856a4fe5106f34b","36":"1a5562a08d12f7682989","38":"31d6cfe0d16ae931b73c","39":"ceebf150d8a696023a14","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"eca8d2b9d77cac3ba3f9","43":"424960769a46ae0ce89c","44":"5f158c492d7bdff6e616","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"d5f94e902f39dcfa1c07","50":"935e1e1fb6425f13083d","51":"bd2a14ee0801f18a9126","52":"d70b0b73ee00761698cd","53":"aea08bdaf10c75486793","54":"e2a1b62b8e1f2aa88b24","55":"592245600ffcc85065d9","56":"be155bb5d11dacdc4bb8","57":"defbf98c233545a10bef","58":"31d6cfe0d16ae931b73c","59":"d70c859b20e57c1599c5","60":"b08202abad6f04bf774d","61":"9d02d79dc9b8f52f7762","62":"7612ae7fca12602593b9","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"e41ee48e4b28f1a4f91c","71":"e518e335254638969e62","72":"b728c81e21e99ee8b48d","73":"d55b1388cb90b7384f58","75":"b8c030d78edc9020543e","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
